import { createI18n } from 'vue-i18n'
import store from '../state/store'
import axios from '../api/axios';
import qs from "qs";

const locked = new Set();

const i18n = createI18n({
    locale: 'hu',
    // fallbackLocale: 'en',
    globalInjection: true,
    missing: async (locale, key) => {
        if (locked.has('run')) {
            return;
        }

        locked.add('run');

        const data = {translationKey: key};
        const translation = await axios.get(`translation/${locale}`, { params: data, paramsSerializer: params => qs.stringify(params, { encodeValuesOnly: true })  }).catch((e) => {
            console.log(e.response?.data.message);
        });

        locked.delete('run');

        const value = translation?.data;

        // Csak valódi lokalizációs objektumot mergelünk: ha a végpont bármiért
        // nem JSON-t ad vissza (pl. SPA fallback HTML), a mergeLocaleMessage
        // "Invalid value"-val elszállna és megdöntené az appot.
        if (value && typeof value === 'object') {
            i18n.global.mergeLocaleMessage(locale, value);
        }

        return value?.[key] || key; // vagy: return 'N/A', null, stb.
    }
})

store.$t = i18n.global.t
store.$rt = i18n.global.rt
store.$tc = i18n.global.tc
store.$te = i18n.global.te
store.$tm = i18n.global.tm
store.$d = i18n.global.d
store.$n = i18n.global.n

export default i18n
